import { render, staticRenderFns } from "./DumbappSubmissionPage.vue?vue&type=template&id=3886778f&"
import script from "./DumbappSubmissionPage.vue?vue&type=script&lang=js&"
export * from "./DumbappSubmissionPage.vue?vue&type=script&lang=js&"
import style0 from "./DumbappSubmissionPage.vue?vue&type=style&index=0&id=3886778f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports